import { equals } from 'ramda';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { landingApi } from '../../api';
import { setActionUrl, setFinancePlatformEnabled, setOffersLength } from '../../redux/landingSlice';
import { selectPrefetchedOffersData, selectPrefetchedOffersRequest, selectUtmTags } from '../../selectors/landing';
import { ICalculatorMcfValues } from '../../types/features';
import { buildGetOfferListingRequest, getMapOffers } from '../../utils/offers';

export const useGetMappedOffers = (calculatorValues: ICalculatorMcfValues) => {
  const dispatch = useDispatch();
  const prefetchedData = useSelector(selectPrefetchedOffersData);
  const prefetchedRequest = useSelector(selectPrefetchedOffersRequest);

  const requestObject = useMemo(() => buildGetOfferListingRequest(calculatorValues), [calculatorValues]);

  const requestMatchesPrefetch = prefetchedRequest != null && equals(requestObject, prefetchedRequest);

  const usePrefetched = prefetchedData != null && requestMatchesPrefetch;

  const queryResult = landingApi.endpoints.getOfferListingV2.useQuery(requestObject, {
    skip: usePrefetched,
  });

  const data = usePrefetched ? prefetchedData : queryResult.data;
  const isFetching = usePrefetched ? false : queryResult.isFetching;

  const utmTags = useSelector(selectUtmTags);

  const mappedOffers = data && data.offers ? getMapOffers(data.offers, utmTags) : [];

  // Переносим dispatch вызовы в useEffect, чтобы избежать обновления состояния во время рендеринга
  useEffect(() => {
    if (data && 'actionUrl' in data) {
      dispatch(setActionUrl(data.actionUrl as string));
    }

    if (data && data.meta) {
      dispatch(setFinancePlatformEnabled(data.meta.financePlatformEnabled));
    }

    if (mappedOffers.length > 0) {
      dispatch(setOffersLength(mappedOffers.length));
    } else {
      dispatch(setOffersLength(null));
    }
  }, [data, mappedOffers.length, dispatch]);

  return { mappedOffers, isFetching };
};
